import DealRecommended from '@screens/configuration/deal/recommended'

export default function DealRecommendedPage() {
  return <DealRecommended />
}
